@if (platformBrowser) {
  <div class="page">
    @if (showEditBanner()) {
      <div class="edit-public-tenant-header">
        <app-svg src="/assets/icons/globe-eye.svg"></app-svg>
        <span>You’re viewing your profile</span>
        <a
          [href]="config.correctPicflowUrl + '/a/settings/public-profile'"
          target="_blank"
          appButton
          name="edit"
          location="tenant-profile-page"
          color="primary"
          shape="round"
          height="0"
          size="1"
        >
          Edit Profile
        </a>
        <button
          (click)="showEditBanner.set(false)"
          appButton
          name="close"
          location="tenant-profile-page"
          [iconButton]="true"
          color="simple"
          shape="round"
          height="0"
          class="close-button"
        >
          <app-svg src="/assets/icons/cross.svg"></app-svg>
        </button>
      </div>
    }

    <app-tenant-logo-and-contacts [tenant]="tenant"></app-tenant-logo-and-contacts>
    @if (galleries()) {
      <div class="galleries-container">
        <app-infinite-scroll
          [resultCount]="galleries().length"
          [lastResultId]="lastGallery()?.id"
          [allResultsLoaded]="allGalleriesLoaded()"
          (fetchMore)="fetchMoreGalleries$.next()"
        >
          <app-list-galleries
            [galleries]="galleries()"
            [externalSorting]="tenant.public_gallery_sorting"
            [publicMode]="true"
            [linkGenerator]="galleryLinkGenerator"
            [target]="'_blank'"
          ></app-list-galleries>
        </app-infinite-scroll>
      </div>
      @if (!galleries().length) {
        <div class="no-galleries" [class.with-logo]="tenant.logo_url || tenant.dark_logo_url">
          <span>There are no galleries to show.</span>
        </div>
      }
    }
    @if (tenant.picflow_branding_enabled) {
      <app-made-with-picflow-button [tenantId]="tenant.id"> </app-made-with-picflow-button>
    }
  </div>
} @else {
  <div class="page center tiny loading">
    <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
  </div>
}
